import { FC, HTMLAttributes } from "react";
import classNames from "classnames";
import { ReactComponent as MaleIcon } from "src/Themes/assets/Avatars/Male.svg";
import { ReactComponent as FemaleIcon } from "src/Themes/assets/Avatars/Female.svg";
import { ReactComponent as AvatarIcon } from "src/Themes/assets/Avatars/Avatar.svg";
import { ReactComponent as RemoveIcon } from "src/Themes/assets/clearBtn.svg";
import { ReactComponent as EditIcon } from "src/Themes/assets/Editing.svg";
import st from "./Avatar.module.scss";
import Button from "../Button";

interface IAvatarProps extends HTMLAttributes<HTMLDivElement> {
	avatarUrl?: string | null;
	gender?: "female" | "male" | string;
	size?: number;

	onEdit?: ( type: "remove" | "edit" ) => void;
};

const Avatar: FC<IAvatarProps> = ( { avatarUrl = "", gender, size = 32, onEdit, className, style, ...otherProps } ) => {

	const _size = `${size}px`;
	const _styles = {
		minWidth: _size,
		height: _size
	};

	const renderImg = () => {
		if ( !!avatarUrl ) {
			const avaImgSrc = avatarUrl.includes( window.host ) ? avatarUrl : window.host + avatarUrl;
			return (
				<img 
					alt={"Аватар пользователя"}
					className={st.img}
					src={avaImgSrc}
				/>
			);
		}
		else if ( gender === "female" )
			return <FemaleIcon className={st.img} />;
		else if ( gender === "male" )
			return <MaleIcon className={st.img} />;

		return <AvatarIcon className={st.img} />;
	};

	const classes = classNames( st.avatar, {
		[st.editable]: !!onEdit
	});

	const renderDeleteBtn = () => {
		if ( !onEdit || !avatarUrl ) return null;
		return (
			<Button variant="yellow" className={st.removeBtn} outline onClick={ () => onEdit("remove" ) }>
				<RemoveIcon />
			</Button>
		);
	};

	const renderEditBtn = () => {
		if ( !onEdit ) return null;
		return (
			<button className={st.editBtn} onClick={ () => onEdit("edit") } >
				<EditIcon />
			</button>
		);
	};

	return (
		<div className={classes} {...otherProps} style={{ ...style, ..._styles }}>
			{ renderImg() }
			{ renderDeleteBtn() }
			{ renderEditBtn() }
		</div>
	);
};

export default Avatar;
